import React, { useRef, useState, useEffect } from 'react';
import {
    Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel,
    FormGroup, Grid, TextField, Typography, FormLabel, RadioGroup, Radio
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import FoodAlloc from './FoodAlloc';
import dayjs from 'dayjs';

const columns = [
    { id: 'RowNum', label: 'Sr.No', minWidth: 170 },
    { id: 'MealTypeName', label: 'FoodClassName', minWidth: 170 },
    { id: 'Abrv', label: 'Abrv', minWidth: 170 },
    { id: 'Remark', label: 'Remark', minWidth: 170 },
];

const MealType = () => {
    const [formData, setFormData] = useState({
        MealTypeName: '',
        Abrv: '',
        Remark: '',
        ReqTiming: dayjs().format('HH:mm'),
        CancelTiming: dayjs().add(30, 'minute').format('HH:mm'),
        IsTfnService: 'N',
    });
    const [error, setError] = useState({
        FoodClass: false,
        FoodAbvr: false
    });
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [mealTypeId, setMealTypeId] = useState(null);
    const [lastInsertedId, setLastInsertedId] = useState(null);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const location = useLocation();
    const navigate = useNavigate();
    const foodClassRef = useRef(null);
    const foodAbrvRef = useRef(null);
    const remarkRef = useRef(null);
    const reqTimingRef = useRef(null);
    const cancelTimingRef = useRef(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [tiffin, setTiffin] = useState('N');

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    useEffect(() => {
        if (location.state && location.state.MealTypeId) {
            setMealTypeId(location.state.MealTypeId);
            fetchMealType(location.state.MealTypeId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location])

    const fetchMealType = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstFood/RetriveMstMealType`, {
                MealTypeId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const foodData = response.data.Data[0];
                setFormData({
                    MealTypeName: foodData.MealTypeName,
                    Abrv: foodData.Abrv,
                    Remark: foodData.Remark,
                    IsTfnService: foodData.IsTfnService,
                    ReqTiming: foodData.Req_LockTime ? foodData.Req_LockTime.slice(0, 5) : '',
                    CancelTiming: foodData.Req_CanlTime ? foodData.Req_CanlTime.slice(0, 5) : ''
                });
                setStatus(foodData.Status.toString() || "0");
                setIsFormDisabled(true);
                setMealTypeId(foodData.MealTypeId);
            }
        } catch (error) {
            toast.error('Error fetching meal type data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('MstFood/GetMstMealTypeDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                })

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (error) {
                toast.error("Error while printing the data.")
            }
        };
        getRow();
    }, [])

    const handlePrevious = async () => {
        if (mealTypeId && mealTypeId > 1) {
            await fetchMealType(mealTypeId, "P");
        }
    };

    const handleNext = async () => {
        if (mealTypeId) {
            await fetchMealType(mealTypeId, "N");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.target === foodClassRef.current) {
                foodAbrvRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        } else if (e.key === 'Tab') {
            if (e.target === foodClassRef.current) {
                foodAbrvRef.current.focus();
            }
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            MealTypeName: '',
            Abrv: '',
            Remark: '',
            ReqTiming: dayjs().format('HH:mm'),
            CancelTiming: dayjs().add(30, 'minute').format('HH:mm'),
            IsTfnService: 'N'
        });
        setMealTypeId(null);
        setTimeout(() => {
            foodClassRef.current.focus();
        }, 0);
    };

    const handleEdit = async () => {
        setMode('edit');
        setIsFormDisabled(false);
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpenConfirmDialog(false);

            const response = await axiosInstance.post('MstFood/DeleteMstMealType', {
                MealTypeId: mealTypeId
            });

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Record deleted.');
                await fetchMealType(mealTypeId, "P");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
            } else {
                toast.warn(response.data.Message || "Failed to delete the record.");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.", { autoClose: 500 });
        }
    };

    const handleExit = () => {
        navigate('/mealtable');
    };

    const formatTime = (time) => {
        return time ? `${time}:00` : null;
    };

    const handleSubmit = async () => {
        let hasError = false;
        if (!formData.MealTypeName) {
            toast.error('Meal Type is required.');
            setError(prev => ({ ...prev, MealTypeName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, MealTypeName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                MealTypeName: formData.MealTypeName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                Status: Status,
                Req_LockTime: formatTime(formData.ReqTiming),
                Req_CanlTime: formatTime(formData.CancelTiming),
                IsTfnService: formData.IsTfnService,
            };
            let response;
            if (mode === 'edit') {
                payload.MealTypeId = mealTypeId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFood/UpdateMstMealType', payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post('MstFood/InsertMstMealType', payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedId(response.data.Data)
                    await fetchMealType(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setMealTypeId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.info(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error("Error while saving.");
        }
    };

    const handleCancel = async () => {
        try {
            await fetchMealType(1, "L");
            setStatus("1");
            setMode("view");
            setIsFormDisabled(true);
        } catch (error) {
            toast.error("Error while canceling.");
        }
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    return (
        <>
            <Box className='form-container' sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' } }}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant='contained'
                                size='small'
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF' }}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant='h5'
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Meal Timing Master
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName={"Meal Timing"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id='MealTypeName'
                                    name='MealTypeName'
                                    label={<span>Meal Type<span style={{ color: 'red' }}>*</span></span>}
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.MealTypeName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodClassRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id='Abrv'
                                    name='Abrv'
                                    label='Abrv'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={foodAbrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl>
                                    <Box display="flex" alignItems="center">
                                        <FormLabel
                                            id="demo-row-radio-buttons-group-label"
                                            sx={{ mr: 2, color: '#000' }}
                                        >
                                            Tiffin Service:
                                        </FormLabel>
                                        <RadioGroup
                                            row
                                            value={formData.IsTfnService}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, IsTfnService: e.target.value }))
                                            }
                                        >
                                            <FormControlLabel value="Y" disabled={isFormDisabled} control={<Radio size="small" />} label="Yes" />
                                            <FormControlLabel value="N" disabled={isFormDisabled} control={<Radio size="small" />} label="No" />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id='Remark'
                                    name='Remark'
                                    label='Timing'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id='ReqTiming'
                                    name='ReqTiming'
                                    label='ReqTiming'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.ReqTiming}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={reqTimingRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id='CancelTiming'
                                    name='CancelTiming'
                                    label='CancelTiming'
                                    variant='filled'
                                    fullWidth
                                    className='custom-textfield'
                                    value={formData.CancelTiming}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={cancelTimingRef}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={6} lg={2}>
                                <Button variant='contained' size='small' color='success' onClick={handleDialogOpen} disabled={isFormDisabled}>
                                    Allocate Food
                                </Button>
                            </Grid> */}
                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label='Status'
                                    />
                                </FormGroup>
                            </Grid>


                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_button'>
                        {mode === 'view' && (
                            <>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit} disabled>
                                    Cancel
                                </Button>
                            </>
                        )}

                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant='contained' sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <FoodAlloc open={openDialog} handleClose={handleCloseDialog} />

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title='Meal Type Master'
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby='alert-dialog-title'
                area-describedby='alert-dialog-description'
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        Are you sure want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button size='small' sx={{
                        backgroundColor: 'red',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'red',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button size='small' sx={{
                        backgroundColor: 'green',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'green',
                            color: '#ffffff'
                        }
                    }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MealType;
